import React from 'react'

import AccommodationSummaryCard from './AccommodationSummaryCard'
import CustomItemSummaryCard from './CustomItemSummaryCard'
import ExperienceItemSummaryCard from './ExperienceItemSummaryCard'
import FlightItemSummaryCard from './FlightItemSummaryCard'
import TransportItemSummaryCard from './TransportItemSummaryCard'

import type { TripItem } from 'tripPlanner/types/tripItem'
import { assertUnreachable } from 'tripPlanner/utils'

interface Props {
  className?: string
  item: TripItem
  showCloseButton?: boolean
  onClose?: () => void
}

const TripItemSummaryCard = React.forwardRef<HTMLDivElement, Props>(
  ({ className, item, showCloseButton, onClose }, ref) => {
    switch (item.type) {
      case 'ACCOMMODATION':
        return (
          <AccommodationSummaryCard
            className={className}
            item={item}
            showCloseButton={showCloseButton}
            onClose={onClose}
            ref={ref}
          />
        )
      case 'EXPERIENCE':
        return (
          <ExperienceItemSummaryCard
            className={className}
            item={item}
            showCloseButton={showCloseButton}
            onClose={onClose}
            ref={ref}
          />
        )
      case 'ATTRACTION':
      case 'THING_TO_DO':
      case 'RESTAURANT_BAR':
      case 'EVENT':
        return (
          <CustomItemSummaryCard
            className={className}
            item={item}
            showCloseButton={showCloseButton}
            onClose={onClose}
            ref={ref}
          />
        )
      case 'FLIGHT':
        return (
          <FlightItemSummaryCard
            item={item}
            ref={ref}
            showCloseButton
            onClose={onClose}
          />
        )
      case 'BUS':
      case 'FERRY':
      case 'TRAIN':
      case 'OTHER_TRANSPORT':
        return (
          <TransportItemSummaryCard
            item={item}
            ref={ref}
            showCloseButton
            onClose={onClose}
          />
        )
      case 'CAR_RENTAL':
      case 'CRUISE':
      case 'TOUR':
      case 'NOTE':
        return null
      default:
        assertUnreachable(item)
    }
  },
)

TripItemSummaryCard.displayName = 'TripItemSummaryCard'
export default TripItemSummaryCard
